export default __webpack_public_path__ + "4e86f36b9f5e22d0f6a9b02f5e4b4180.svg";